<template>
  <b-modal
    id="myid"
    ref="modal"
    title="유닛 생성"
    @show="resetModal"
    @ok="handleOk"
  >
    <b-overlay :show="loading" rounded="sm">
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="유닛명"
          label-for="title"
          invalid-feedback="유닛명은 비어있을수 없습니다."
          :state="titleState"
        >
          <b-form-input
            id="title"
            v-model="title"
            :state="titleState"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="공통코드"
          label-for="code"
          invalid-feedback="콩통코드는 비어있을수 없습니다"
          :state="codeState"
        >
          <b-form-input
            id="code"
            v-model="cmm_code"
            :state="codeState"
            required
          ></b-form-input>
        </b-form-group>
      </form>
      <b-alert show variant="danger">
        <ul>
          <li>
            공통코드를 참조하여 저장즉시 문항의 챕터, 유닛 정보가 업데이트
          </li>
          <li>공통코드 수정시 기존 매핑되어있던 문항의 챕터,유닛정보는 유지</li>
        </ul>
      </b-alert>
    </b-overlay>
  </b-modal>
</template>

<script>
import * as _ from "lodash";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
export default {
  props: ["formUnit"],
  data() {
    return {
      title: null,
      titleState: null,
      codeState: null,
      loading: false,
      cmm_code: null,
      id: null,
    };
  },
  computed: {
    ...mapState("chapterStore", ["chapter", "book_id"]), //chapter : 챕터 아이디를 가져오기 위해 필요
  },
  methods: {
    ...mapActions("chapterStore", ["postUnit", "putUnit", "getUnitList"]),
    resetModal() {
      this.title = this.formUnit.utitle;
      this.cmm_code = this.formUnit.cmm_code;
      this.id = this.formUnit.id;

      this.loading = false;
      this.titleState = null;
      this.codeState = null;
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.codeState = _.isEmpty(this.cmm_code) ? false : true;
      this.titleState = _.isEmpty(this.title) ? false : true;
      return valid;
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    async handleSubmit() {
      if (!this.checkFormValidity()) {
        return;
      }

      this.loading = true;

      if (this.id != undefined) {
        let resp = await this.putUnit({
          utitle: this.title,
          cmm_code: this.cmm_code,
          pid: this.chapter.id,
          id: this.id,
        });
      } else {
        let resp = await this.postUnit({
          utitle: this.title,
          cmm_code: this.cmm_code,
          pid: this.chapter.id,
        });
      }
      this.loading = false;
      let $this = this;
      this.$nextTick(() => {
        this.$bvModal.hide("myid");

        let query = {
          flag: 1,
          subflag: $this.chapter.id,
          book_id: $this.book_id,
        };
        this.getUnitList(query);
      });
    },
  },
};
</script>


<style lang="scss" scoped>
</style>